module.exports = __webpack_public_path__ + "static/media/chromeindex.7eb513e0.png";